import React from "react";
import { AppSizes } from "../../../theme/";
import _ from "lodash";

import { Image, ImageBackground, Modal, StyleSheet, Text, TouchableOpacity, TouchableWithoutFeedback, View } from "react-native";
import { Body, Button, Container, Content, Footer, Left, Right, Title } from "native-base";
import Icon from "react-native-vector-icons/Ionicons";
import * as Helper from "../../../utils/Helper";
import * as WebHelper from "../../../utils/WebHelper";
import Header from "../../../components/ui/WrappedHeader";
import Loading from "../../../components/general/Loading";
import LDResultRender from "../../../components/ui/LDResultRender";
import CommonModal from "../../../components/ui/CommonModal";
import Video from "react-native-video";
import SpokenReadingResultView, { WavingLineWrapper } from "./share/SpokenReadingResultView";
import { NavigationService } from "../../../navigation";
import UIDs from "../../../UIDs";
import SpokenStyle from "../../course/units/SpokenStyle";
import { PlayingAudio } from "../../course/units/base/SpokenReadingUnit";
import AppConfig from "../../../config/AppConfig";
import Constants from "../../../config/Constants";
import { withTranslation } from "react-i18next";

import SimpleSentence from "../../../components/ui/SimpleSentence";
import Paragraph from "../../../components/ui/Paragraph";
import NextButtonStyle from "../NextButtonStyle";

const uid = UIDs.screens.homework.resultviews.poka3resultview;
class POKA3ResultView extends SpokenReadingResultView {
    constructor(props) {
        super(props);

        let { answer } = _.cloneDeep(props.result) || {};

        if (!answer) answer = {};
        let files = answer.wavFilePath ? [answer.wavFilePath] : [];
        if (props.readonly) {
            files = answer.audioPath ? [answer.audioPath] : [];
        }
        let remoteFiles = answer.audioPath ? [answer.audioPath] : [];
        //const { words, audioPath, translation, sentenceCommand, sentenceCommandSetting } = this.props.data;
        this.state = {
            ...this.state,
            paused: true,
            audioPath: "",
            playingAll: false,
            recording: false,
            endRecording: false,
            reIdentifing: false,
            showResultDialogIndex: null,
            lastAnswer: answer,
            currAnswer: {},
            remoteFiles: remoteFiles && remoteFiles.length > 0 ? remoteFiles[0] : "",
            oriFiles: files && files.length > 0 ? files[0] : "",
            words: null,
            answer: answer,
            subjectPoints: 0,
        };
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        this._handleStopAllAudio();
        this._handleCloseDialog();
    }

    get userResultFull() {
        let fileArr = [];
        let getPoints = 0;
        let answer = this.state.answer;
        let wavFilePath = this.state.oriFiles || "";
        answer.wavFilePath = wavFilePath;
        fileArr.push(wavFilePath);

        let totalChars = this._totalChars(answer);
        let deductPoints = this._deductPoints(answer);
        getPoints += totalChars + deductPoints;
        if (getPoints < 0) {
            getPoints = 0;
        }

        return { files: fileArr, answer: this.state.answer, score: this.props.readonly ? this.props.data.totalScore / 100 : totalChars !== 0 ? getPoints / totalChars : 0 };
    }

    get userResult() {
        let r = this.userResultFull;

        // 返回给服务器的数据, 去掉files
        delete r.files;

        // 重新设置audioPath为remote地址
        r.answer = _.cloneDeep(r.answer);
        r.answer.audioPath = this.state.remoteFiles;

        return r;
    }

    _totalChars = answer => {
        //一句话总字数（不包括标点符号）
        return Helper.getUserReadingAnswerTotalChars(answer);
    };

    _getWrongChars = answer => {
        let { result = {} } = answer || {};
        let totalChars = this._totalChars(answer);
        let wrongChars = result.nodeArray ? result.substitutions + result.inserts + result.deletes : totalChars;
        if (wrongChars > totalChars) wrongChars = totalChars;
        return wrongChars;
    };

    _deductPoints = answer => {
        let { result = {} } = answer || {};
        let totalChars = this._totalChars(answer);
        let deductPoints = result.nodeArray ? -(result.substitutions + result.inserts + result.deletes) : -totalChars; //扣分数
        return deductPoints;
    };

    _deductScore = answer => {
        let deductPoints = this._deductPoints(answer);
        let deductScore = this.state.subjectPoints !== 0 ? (deductPoints * 100) / this.state.subjectPoints : 0;
        if (deductScore < 0 && deductScore > -0.5) deductScore = -1;
        return _.round(deductScore, 0);
    };

    _handleViewRankingList = () => {
        this._handleStopAllAudio();
        if (this.props.goToRanking) {
            this.props.goToRanking();
        } else {
            NavigationService.navigateToPage(this, UIDs.screens.homework.classranking, { userHomeworkUnitId: this.props.data.userHomeworkUnitId });
        }
    };

    _handleClose = () => {
        this.close();
    };

    _handleContinue = () => {
        let { answer, score } = this.userResultFull;
        let { words, chars, wavFilePath, result = {} } = answer;
        let { wholeWordCount, nodeArray: nodes } = result;
        let totalChars = this._totalChars(answer);
        let deductPoints = this._deductPoints(answer);
        let isRecognized = nodes && (wholeWordCount > 0 || result.deletes !== totalChars);

        if (!isRecognized) {
            var options = {
                body: <Text>{this.props.t("hasRecognizeError")}</Text>,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: this.props.t("continueWork"),
                cancelButtonText: this.props.t("nextUnit"),
                onCancelButtonPress: () => {
                    this._handleCloseCommonModal();
                    this.continue();
                },
                onConfirmButtonPress: this._handleCloseCommonModal,
                tapOutsideCloseCallBack: this._handleCloseCommonModal,
            };
            this.localVars.commonModalRef.show(options);
            this.props.showCommonModalRef(true);
            return;
        }

        this.continue();
    };

    _handleCloseCommonModal = () => {
        this.localVars.commonModalRef.hide();
        this.props.showCommonModalRef(false);
    };

    _handleRerecording = () => {
        this.restart();
    };

    isActionExecuting = actionState => {
        return (Object.keys(actionState) || []).findIndex(index => actionState[index]) > -1;
    };

    render() {
        const { rank, useState, vipEnabled } = this.props.data;
        console.log(`recording - ${this.state.recording}`);
        let { answer, score } = this.userResultFull;
        let subjectScore = _.round(score * 100, 0);
        let resultView = null;
        if (vipEnabled) {
            resultView = (
                <>
                    <View style={[styles.marginHorizontal10, { flex: 1 }]}>
                        {/* <FlatList
                                contentContainerStyle={{ paddingBottom: 10 }}
                                data={answerArr}
                                keyExtractor={item => item.dialogIndex}
                                renderItem={({item, index}) => this._renderItem(item, index, size)}
                            /> */}
                        {this._renderItem(answer)}
                    </View>
                </>
            );
        }

        let rate = 1;
        if (!this.userResultFull.files.includes(this.state.audioPath)) {
            rate = this.localVars.robotAudioRate;
        }

        let grade = Constants.HOMEWORK_RESULT_GRADE.PERFECT;
        let gradeColor = "#25d07b";
        let scoreColor = "#ffe005";
        if (subjectScore < 70) {
            grade = Constants.HOMEWORK_RESULT_GRADE.PITY;
            gradeColor = "#49acf8";
            scoreColor = "#fa6625";
        } else if (subjectScore < 90) {
            grade = Constants.HOMEWORK_RESULT_GRADE.GOOD;
            gradeColor = "#ffb007";
        } else if (subjectScore < 100) {
            grade = Constants.HOMEWORK_RESULT_GRADE.EXCELLENT;
            gradeColor = "#ffb007";
        }

        return (
            <Container>
                {this.state.showTimeoutTips && (
                    <View
                        style={{
                            position: "absolute",
                            top: 34,
                            width: "100%",
                            zIndex: 999,
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            backgroundColor: "white",
                            paddingHorizontal: 10,
                            paddingVertical: 5,
                        }}>
                        <SimpleSentence style={{ marginRight: 15 }}>{this.props.t("timeoutTips", { seconds: AppConfig.MAX_AUDIO_RECORD_LIMIT || 55 })}</SimpleSentence>
                        <TouchableOpacity style={{ marginLeft: -10 }} onPress={() => this.setState({ showTimeoutTips: false })}>
                            <Icon size={30} name="ios-close" />
                        </TouchableOpacity>
                    </View>
                )}
                <Video
                    key={this.state.audioPath /* 解决ios bug: https://github.com/react-native-video/react-native-video/pull/650 */}
                    audioOnly={true}
                    rate={rate}
                    paused={this.state.paused}
                    source={{ uri: Helper.convertToAbsoluteUrl(this.state.audioPath) }} // Can be a URL or a local file.
                    ref={self => {
                        this.player = self;
                    }} // Store reference
                    onLoad={data => {
                        this.setState({ audioDuration: (data.duration * 1000) / rate });
                    }}
                    onError={() => {
                        if (!this.state.paused) {
                            this._handleStopAudio();
                        }
                    }}
                />
                {!this.state.paused && this.state.audioDuration > 0 && <PlayingAudio duration={this.state.audioDuration} onEnd={this._handleStopAudio} />}
                <ImageBackground source={require("../../../images/homework/result/background.png")} style={{ width: "100%" }}>
                    {this.props.readonly ? (
                        <View style={{ width: "100%", flexDirection: "row", paddingHorizontal: 15, paddingTop: 5 }}>
                            <Left style={styles.flex1} />
                            <Body style={[styles.flex3, styles.alignItemsCenter]}>
                                <Title style={styles.headerTitle}>{this.props.t("practiceResult")}</Title>
                            </Body>
                            <Right style={styles.flex1}>
                                {/*
                                <TouchableOpacity transparent onPress={this._handleViewRankingList}>
                                    <Image source={require("../../../images/homework/result/ranking.png")} style={{ width: 16, height: 16 }} />
                                </TouchableOpacity>
                                 */}
                            </Right>
                        </View>
                    ) : (
                        <Header transparent style={{ width: "100%" }} bottomColor="transparent">
                            <Left style={styles.flex1}>
                                <TouchableOpacity transparent disabled={this.state.recording} onPress={this._handleClose}>
                                    <Icon style={[styles.closeIcon]} size={30} name="ios-close" />
                                </TouchableOpacity>
                            </Left>
                            <Body style={[styles.flex3, styles.alignItemsCenter]}>
                                <Title style={styles.headerTitle}>{this.props.t("practiceResult")}</Title>
                            </Body>
                            <Right style={styles.flex1}>
                                {/* hide rank when reviewing */}
                                {/*
                                {this.props.mode !== 3 && (
                                    <TouchableOpacity transparent disabled={this.state.recording}
                                                      onPress={this._handleViewRankingList}>
                                        <Image source={require("../../../images/homework/result/ranking.png")} style={{ width: 16, height: 16 }} />
                                    </TouchableOpacity>
                                )}
                                 */}
                            </Right>
                        </Header>
                    )}
                    <View style={[styles.centerAlign, { marginTop: this.props.readonly ? 10 : -10 }]}>
                        <SimpleSentence style={{ fontSize: 42, color: scoreColor, marginTop: 5 }}>
                            <SimpleSentence style={{ fontWeight: "bold" }}>{subjectScore}</SimpleSentence>
                            <SimpleSentence>{this.props.t("scores")}</SimpleSentence>
                        </SimpleSentence>
                        <SimpleSentence style={{ fontSize: 25, color: gradeColor, fontWeight: "bold", marginVertical: 10 }}>{grade}</SimpleSentence>
                        {/* hide rank when reviewing */}
                        {/*this.props.mode !== 3 && <SimpleSentence style={{ color: "#fff", paddingBottom: 15 }}>{this.props.t("rankInClass", { rank: rank || "0" })}</SimpleSentence>*/}
                    </View>
                </ImageBackground>
                <Content>
                    <View style={[styles.row, styles.alignItemsCenter, { height: 55, borderBottomWidth: 2, borderBottomColor: "#F4F4F4" }]}>
                        {!this.state.playingAll || this.state.paused ? (
                            <TouchableOpacity
                                style={[styles.row, styles.centerAlign, { paddingLeft: 20, paddingRight: 20, marginHorizontal: 10, height: 30, borderRadius: 18, backgroundColor: this.wavFiles ? "#22D59E" : "#ccc" }]}
                                transparent
                                disabled={this.state.recording || (!this.wavFiles)}
                                onPress={this._handlePlayAllAudios}>
                                <Icon size={20} name="ios-volume-high" style={{ color: "#fff", marginRight: 10 }} />
                                <Text style={{ color: "#fff", fontSize: 14, fontWeight: "bold" }}>{this.props.t("play")}</Text>
                            </TouchableOpacity>
                        ) : (
                            <TouchableOpacity
                                style={[styles.row, styles.centerAlign, { paddingLeft: 20, paddingRight: 20, marginHorizontal: 10, height: 30, borderRadius: 18, backgroundColor: "#777" }]}
                                transparent
                                disabled={this.state.recording}
                                onPress={this._handleStopAllAudio}>
                                <Icon size={14} name="md-square" style={{ color: "#fff", marginRight: 10 }} />
                                <Text style={{ color: "#fff", fontSize: 14, fontWeight: "bold" }}>{this.props.t("stop")}</Text>
                            </TouchableOpacity>
                        )}
                        {this.props.readonly ? (
                            <TouchableOpacity style={[styles.row, styles.centerAlign, styles.btnTopic, { marginRight: 10 }]} transparent onPress={this.props.showTopic}>
                                <Text style={{ color: "#22D59E", fontWeight: "bold" }}>{this.props.t("topic")}</Text>
                            </TouchableOpacity>
                        ) : (
                            <TouchableOpacity
                                style={[
                                    styles.row,
                                    styles.centerAlign,
                                    { paddingLeft: 20, paddingRight: 20, marginHorizontal: 10, height: 30, borderRadius: 18, borderWidth: 1, borderColor: "#22D59E" },
                                ]}
                                disabled={this.state.playingAll || this.state.recording}
                                transparent
                                onPress={this._handleRerecording}>
                                <Image source={require("../../../images/homework/re-recorded2.png")} style={{ height: 20, width: 20, marginRight: 10 }} />
                                <Text style={{ color: "#22D59E", fontSize: 14, fontWeight: "900" }}>{this.props.t("rerecording")}</Text>
                            </TouchableOpacity>
                        )}
                    </View>
                    <View style={[styles.flex6]}>
                        <View style={[styles.marginHorizontal10, { marginTop: 10 }]}>
                            <View style={[styles.row, { justifyContent: "space-between" }]}>
                                <SimpleSentence style={{ color: "#C1C1C1", fontWeight: "600" }}>
                                    {this.props.t("errAnalysis")}
                                    {AppConfig.ENABLE_PAYMENT ? this.props.t("vip") : null}
                                </SimpleSentence>
                                { AppConfig.ENABLE_PAYMENT ? (
                                    <TouchableOpacity
                                        disabled={this.state.recording}
                                        style={{ borderBottomWidth: 1, paddingBottom: 1, borderBottomColor: "#ffb007" }}
                                        onPress={() => this._handleBuyVip()}>
                                        <SimpleSentence style={{ color: "#ffb007", fontWeight: "600" }}>{this.props.t("buyVIP")}</SimpleSentence>
                                    </TouchableOpacity>
                                ) : null}
                            </View>
                            {AppConfig.ENABLE_PAYMENT ? <SimpleSentence style={{ marginTop: 6, color: "#ffb007", fontSize: 12 }}>{useState || ""}</SimpleSentence>: null}
                        </View>
                        {resultView}
                    </View>
                </Content>
                {!this.props.readonly && (
                    <Footer style={{ backgroundColor: "transparent" }}>
                        <View style={[NextButtonStyle.btnNextView]}>
                            <TouchableOpacity style={[NextButtonStyle.btnNext]} transparent disabled={this.state.recording} onPress={this._handleContinue}>
                                <Text style={NextButtonStyle.btnNextText}>{this.props.t("next")}</Text>
                            </TouchableOpacity>
                        </View>
                    </Footer>
                )}
                <CommonModal childRef={ref => (this.localVars.commonModalRef = ref)} />
            </Container>
        );
    }

    _renderItem = answer => {
        let { words, chars, wavFilePath, result = {} } = answer;
        let { audioPath } = this.props.data.content;
        const { language="zh", unitOptions } = this.props.data;
        let pinyinVisible = true
        if(language !=="zh"){
            pinyinVisible = false;
        }

        let writingVisible = true;
        if (unitOptions) {
            if (unitOptions.enableWriting !== undefined && !unitOptions.enableWriting) {
                pinyinVisible = false;
                writingVisible = false;
            }

            if (!unitOptions.enablePinYin) {
                pinyinVisible = false;
            }
        }

        let errMsg = null;
        if (result.error) {
            try {
                errMsg = JSON.parse(result.error.message || null);
            } catch {
                errMsg = { code: result.error.code, desc: result.error.message };
            }
        }

        if (WebHelper.isSafari()) {
            // NOTE: safari不支持播放blob url
            wavFilePath = answer.audioPath;
        }

        let { wholeWordCount, nodeArray: nodes } = result;
        let totalChars = this._totalChars(answer);
        let deductPoints = this._deductPoints(answer);
        let lastDeductPoints = this.state.lastAnswer ? this._deductPoints(this.state.lastAnswer) : null;
        let isRecognized = nodes && (wholeWordCount > 0 || result.deletes !== totalChars);
        let wrongChars = this._getWrongChars(answer);

        let reIdentifyDisabled = this.state.endRecording || this.state.reIdentifing;
        let isNoAnswer = answer && answer.chars && answer.chars.length > 0 ? false : true;  //如果没有回答题目则直接是0分
        let sentencePs = (isNoAnswer ? -100 : ((-wrongChars / totalChars) * 100)).toFixed(1).split(".");

        return !this.state.recording ? (
            <View style={[{ marginTop: 10, backgroundColor: "#a9ea7a", borderRadius: 8 }]}>
                <View style={{ borderBottomColor: "#E7E7E7", borderBottomWidth: 1, paddingHorizontal: 10, paddingVertical: 10 }}>
                    <View style={{flex:1, display:"inline"}}>
                        {/*chars &&
                            chars.split("").map((char, idx) => (
                                <SimpleSentence key={idx} style={{ color: "#868686", ...SpokenStyle.dialogsFontSize, ...SpokenStyle.dialogsLineHeight }}>
                                    {char}
                                </SimpleSentence>
                            ))*/}
                        {writingVisible ?
                         (<div style={{float:"left"}}><Paragraph
                            data={{ sentences: [this.props.data.content] }}
                            language={this.props.data.language}
                            pinyinVisible={pinyinVisible}
                            disableExplanation={true}
                            style={{ ...SpokenStyle.srcSentenceColor, ...SpokenStyle.dialogsFontSize, paddingVertical: 0, paddingHorizontal: 0 }}
                            pinyinStyle={{ ...SpokenStyle.pinyinFontSize }}
                            letterStyle={{ marginTop: language === "zh" ? 0 : 14}}
                         /></div>) : null}
                        {/*<SimpleSentence style={{ color: "#868686", ...SpokenStyle.dialogsFontSize, ...SpokenStyle.dialogsLineHeight }}>{this.props.t("totalChars", { totalChars })}</SimpleSentence>*/}
                        <div style={{float:"left", marginTop:10}}>{this.state.paused || !audioPath || this.state.audioPath !== audioPath ? (
                            <TouchableOpacity
                                onPress={() => {
                                    this._handleStopAllAudio();
                                    this._handlePlayAudio(audioPath);
                                }}>
                                <Icon size={24} name="ios-volume-high" style={[SpokenStyle.srcSentenceColor, { marginLeft: 10 }]} />
                            </TouchableOpacity>
                        ) : (
                            <TouchableOpacity onPress={this._handleStopAllAudio} style={{ height: 25 }}>
                                <Icon size={18} name="md-square" color="#777" style={{ marginLeft: 10, marginTop: 2 }} />
                            </TouchableOpacity>
                        )}</div>
                    </View>
                    <View style={[styles.row, styles.alignItemsCenter, { marginTop: 5, display: "flex", flexWrap: "wrap" }]}>
                        {isRecognized ? (
                            <>
                                <LDResultRender language={language} showRealAnswer={true} nodes={nodes} style={{ ...SpokenStyle.srcSentenceColor, ...SpokenStyle.dialogsFontSize, ...SpokenStyle.dialogsLineHeight }} />
                                {/*<SimpleSentence style={{ color: "#66bb6a", ...SpokenStyle.dialogsFontSize, ...SpokenStyle.dialogsLineHeight }}>
                                    {this.props.t("totalChars", { totalChars: wholeWordCount })}
                                </SimpleSentence>*/}
                            </>
                        ) : (
                            <>
                                <SimpleSentence style={{ color: "#e53935", ...SpokenStyle.dialogsFontSize, ...SpokenStyle.dialogsLineHeight }}>{this.props.t("aiNoRecog")}</SimpleSentence>
                                {errMsg ? (
                                    <SimpleSentence style={{ marginTop: 5, ...SpokenStyle.dialogsFontSize, ...SpokenStyle.dialogsLineHeight }}>
                                        ({errMsg.desc}, {errMsg.code})
                                    </SimpleSentence>
                                ) : null}
                            </>
                        )}
                        {wavFilePath !== audioPath &&
                            (this.state.paused || !wavFilePath || this.state.audioPath !== wavFilePath ? (
                                <TouchableOpacity
                                    onPress={() => {
                                        this._handleStopAllAudio();
                                        this._handlePlayAudio(wavFilePath);
                                    }}>
                                    <Icon size={24} name="ios-volume-high" style={{ ...SpokenStyle.srcSentenceColor, marginLeft: 10 }} />
                                </TouchableOpacity>
                            ) : (
                                <TouchableOpacity onPress={this._handleStopAllAudio} style={{ height: 25 }}>
                                    <Icon size={18} name="md-square" color="#777" style={{ marginLeft: 10, marginTop: 2 }} />
                                </TouchableOpacity>
                            ))}
                        {!this.props.readonly && !isRecognized ? (
                            <TouchableOpacity disabled={reIdentifyDisabled} onPress={() => this._handleReIdentification(answer)} style={{ marginLeft: 8, flexDirection: 'row', backgroundColor: "#22D59E", alignItems: "center", justifyContent: 'center', paddingHorizontal: 4, paddingVertical: 2, height: 24, borderRadius: 12 }}>
                                <Icon name="md-refresh-circle" size={22} style={{ color: "#fff", marginRight: 4 }} />
                                <Text style={{fontSize: 11, color: '#fff'}}>{this.props.t('reidentification')}</Text>
                            </TouchableOpacity>
                        ) : null}
                    </View>
                </View>
                {/*{!this.props.readonly && (*/}
                    <View style={[styles.row, styles.centerAlign, { padding: 10 }]}>
                        {!this.state.reIdentifing ? (
                            result.passed ? (
                                <SimpleSentence style={{ color: "#ffb007", fontWeight: "bold", ...SpokenStyle.dialogsFontSize }}>Perfect!</SimpleSentence>
                            ) : (
                                <View style={[styles.row, styles.centerAlign, styles.flex1]}>
                                    {!this.props.readonly ? <Button
                                        transparent
                                        onPress={() => this._handleRecordOne(answer)}
                                        style={[styles.centerAlign, {
                                            paddingHorizontal: 15, paddingVertical: 5, height: 30, borderRadius: 8,
                                            marginRight: 10, backgroundColor: "#6ae6a8"
                                        }]}>
                                        <Text style={{
                                            color: "#fff", fontSize: 16
                                        }}>{this.props.t("singleRerecording")}</Text>
                                    </Button>: null}
                                    {/*this.props.t("fault") ? <Text style={{ color: "#e53935", fontSize: 14, marginRight: 2 }}>{this.props.t("fault")}</Text> : null*/}
                                    <Text style={{ color: "#e53935", fontWeight: "bold", marginRight: 2, fontSize: 21 }}>{sentencePs[0]}</Text>
                                    <Text style={{ color: "#e53935", fontWeight: "bold", fontSize: 14, marginRight: 5, marginTop: 5 }}>
                                        .{sentencePs[1]} {this.props.t(deductPoints < -1 ? "points" : "point")}
                                    </Text>
                                    {lastDeductPoints !== null &&
                                        (deductPoints < lastDeductPoints ? (
                                            <Image source={require("../../../images/homework/result/drop.png")} style={{ resizeMode: "stretch", height: 12, width: 8 }} />
                                        ) : deductPoints > lastDeductPoints ? (
                                            <Image source={require("../../../images/homework/result/improvement.png")} style={{ resizeMode: "stretch", height: 12, width: 8 }} />
                                        ) : null)}
                                </View>
                            )
                        ) : (
                            <Loading transparent />
                        )}
                        {this.state.showResultDialogIndex ? this._renderDialog({ lastAnswer: this.state.lastAnswer, currAnswer: this.state.currAnswer }) : null}
                    </View>
                {/*)}*/}
            </View>
        ) : (
            <View style={[{ marginTop: 10, borderRadius: 8 }]}>
                <View style={{ paddingHorizontal: 10, paddingBottom: 5 }}>
                    <View style={[styles.row, styles.alignItemsCenter, { display: "flex", flexWrap: "wrap" }]}>
                        {/*chars.split("").map((char, idx) => (
                            <SimpleSentence key={idx} style={{ color: "#000", fontWeight: "bold", ...SpokenStyle.dialogsFontSize, ...SpokenStyle.dialogsLineHeight }}>
                                {char}
                            </SimpleSentence>
                        ))*/}
                        {writingVisible ?
                         (<Paragraph
                            data={{ sentences: [this.props.data.content] }}
                            language={this.props.data.language}
                            pinyinVisible={pinyinVisible}
                            disableExplanation={true}
                            style={{ color: "#000", fontWeight: "bold", ...SpokenStyle.dialogsFontSize, paddingVertical: 0, paddingHorizontal: 0, flex: 1 }}
                            pinyinStyle={{ ...SpokenStyle.pinyinFontSize }}
                            letterStyle={{ marginTop: language === "zh" ? 0 : 14}}
                          />) : null}
                    </View>
                </View>
                <View style={[styles.row, styles.centerAlign, { height: 75, backgroundColor: "#e6e6e6", paddingTop: !this.state.endRecording ? 0 : 10, overflow: "hidden" }]}>
                    {!this.state.endRecording ? (
                        <WavingLineWrapper height={75} color="blue" title={this.props.t("clickToEndRecord")} onEnd={() => this._setEndRecordingState(true)} />
                    ) : (
                        <Loading transparent />
                    )}
                </View>
            </View>
        );
    };

    _handlePlayAudio = audioPath => {
        console.log("audio path: " + audioPath);
        //Alert.alert(audioPath);
        if (!audioPath) {
            this.setState({ paused: true, playingAll: false });
        } else if (this.player) {
            //on ios same file seems have caching
            //use this to avoid this issue
            this.setState({ audioPath: "", audioDuration: 0 }, () => {
                this.setState({ audioPath }, () => {
                    this.setState({ paused: false });
                });
            });
        }
    };

    get wavFiles() {
        return this.state.oriFiles;
    }

    _handleStopAudio = () => {
        this.setState({ paused: true, audioDuration: 0, playingAll: false });
    };

    _handlePlayAllAudios = () => {
        this.setState({ playingAll: true }, () => {
            if (WebHelper.isSafari()) {
                // NOTE: safari不支持播放blob url
                this._handlePlayAudio(this.state.remoteFiles || "");
            }
            else {
                this._handlePlayAudio(this.wavFiles || "");
            }
        });
    };

    _handleStopAllAudio = () => {
        this.setState({ playingAll: false }, () => {
            this._handleStopAudio();
        });
    };

    _handleBuyVip = () => {
        this._handleStopAllAudio();
        NavigationService.navigateToPage(this, UIDs.screens.me.member, { userHomeworkId: this.props.data.userHomeworkId });
    };

    _setRecordingState = val => {
        this.setState({ recording: val });
    };

    _setEndRecordingState = val => {
        let endRecording = val && this.state.recording;
        if (val) {
            if (this.state.recording) {
                this.endRecord();
            }
        }
        this.setState({ endRecording: endRecording });
    };

    _handleRecordOne = answer => {
        this._handleStopAllAudio();

        let { chars } = answer;
        this._setEndRecordingState(true);

        //传入拼音来进行更准确的判断
        const { words, audioPath, translation, sentenceCommand, sentenceCommandSetting } = this.props.data;
        try {
            this.setSpeechRecognitionReferenceSyllables(words.syllables);
            this.setSpeechRecognitionReferenceMarkText(words.chars.join(""));
        } catch (e) {}

        this.recordingTimeout = setTimeout(() => {
            // 显示录音超时提示，在5秒后自动隐藏
            this.setState({ showTimeoutTips: true });
            this._setEndRecordingState(true);
            setTimeout(() => {
                this.setState({ showTimeoutTips: false });
            }, 5000);
        }, (AppConfig.MAX_AUDIO_RECORD_LIMIT || 55) * 1000);

        const fileName = this.state.oriFiles;
        this.startRecordAndUpload(
            { chars, fileName },
            (file, response, uploadResponse) => {
                console.log(response);
                const error = response.error ? response.error : uploadResponse.error;
                if (error) {
                    this._setRecordingState(false);
                    this._setEndRecordingState(false);
                    this.displayError({ message: error.toString()});
                    return;
                }

                let oriFiles = _.clone(this.state.oriFiles);
                oriFiles = file;

                let answers = _.cloneDeep(this.state.answer);

                answers.result = response;
                answers.wavFilePath = file;
                if (uploadResponse.virtualPath) {
                    answers.audioPath = uploadResponse.virtualPath;
                }

                this._setRecordingState(false);
                this._setEndRecordingState(false);

                let lastAnswer = _.cloneDeep(this.state.lastAnswer);
                lastAnswer = answer;
                let currAnswer = _.cloneDeep(this.state.currAnswer);
                currAnswer = answers;

                this.setState({ oriFiles, answer: answers, lastAnswer: lastAnswer, currAnswer: currAnswer, showResultDialogIndex: 1, remoteFiles: uploadResponse.virtualPath }, () => {
                    this.processUnitResult(this.userResult);
                });
            },
            () => {
                clearTimeout(this.recordingTimeout);
            }
        );

        this._setRecordingState(true);
    };

    _setReIdentifingState = val => {
        let reIdentifing = _.clone(this.state.reIdentifing);
        reIdentifing = val;
        this.setState({ reIdentifing });
    };

    _handleReIdentification = answer => {
        let { chars, wavFilePath } = answer;
        //传入拼音来进行更准确的判断
        const { words, audioPath, translation, sentenceCommand, sentenceCommandSetting } = this.props.data;
        try {
            this.setSpeechRecognitionReferenceSyllables(words.syllables);
            this.setSpeechRecognitionReferenceMarkText(words.chars.join(""));
        } catch (e) {}
        this._setReIdentifingState(true);
        this.startReIdentification(wavFilePath, chars, response => {
            let answers = _.cloneDeep(this.state.answer);
            let newAnswer = answers;
            newAnswer.result = response;

            let lastAnswer = _.cloneDeep(this.state.lastAnswer);
            lastAnswer = answer;
            let currAnswer = _.cloneDeep(this.state.currAnswer);
            currAnswer = newAnswer;

            this._setReIdentifingState(false);
            this.setState({ answer: answers, lastAnswer: lastAnswer, currAnswer: currAnswer, showResultDialogIndex: 1 }, () => {
                this.processUnitResult(this.userResult);
            });
        });
    };

    _handleCloseDialog = () => {
        this.setState({ showResultDialogIndex: null });
    };

    _renderDialog = data => {
        let { currAnswer, lastAnswer } = data;
        let currDeductPoints = this._deductPoints(currAnswer);
        let lastDeductPoints = this._deductPoints(lastAnswer);
        let totalChars = this._totalChars(currAnswer);
        let wrongChars = this._getWrongChars(currAnswer);
        let isNoAnswer = currAnswer && currAnswer.chars && currAnswer.chars.length > 0 ? false : true;  //如果没有回答题目则直接是0分
        let sentencePs = (isNoAnswer ? -100 : ((-wrongChars / totalChars) * 100)).toFixed(1).split(".");

        const modalBackgroundStyle = {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            alignItems: "center",
            justifyContent: "flex-end",
        };
        const modalSize = {
            width: Helper.getContainerSize().width * 0.9,
            height: 300,
            marginBottom: (Helper.getContainerSize().height - 300) * 0.5,
        };
        return (
            <Modal transparent style={{ margin: 0 }} animationType={"none"} onRequestClose={this._handleCloseDialog}>
                <TouchableWithoutFeedback onPress={this._handleCloseDialog}>
                    <View style={[styles.flex1, modalBackgroundStyle]}>
                        {/*make the inner part click event do not bubble up to trigger the _onPressOutSide*/}
                        <TouchableWithoutFeedback
                            onPress={event => {
                                event.stopPropagation();
                            }}>
                            <View style={[modalSize, { backgroundColor: "#fff", borderRadius: 4 }]}>
                                <View style={{ position: "absolute", zIndex: 1, top: 1, right: 10 }}>
                                    <TouchableOpacity transparent onPress={this._handleCloseDialog}>
                                        <Icon style={{ color: "#c8c8c8" }} size={30} name="ios-close" />
                                    </TouchableOpacity>
                                </View>
                                <View style={[styles.centerAlign, { marginTop: 40 }]}>
                                    {currDeductPoints === 0 ? (
                                        <Image source={require("../../../images/homework/result/perfect.png")} style={[{ width: 150, height: 150, resizeMode: "contain" }]} />
                                    ) : currDeductPoints < lastDeductPoints ? ( //下降
                                        <View style={[styles.row, styles.centerAlign, { marginTop: 30 }]}>
                                            <Image source={require("../../../images/homework/result/scoreDrops.png")} style={[{ width: 100, height: 100, resizeMode: "contain" }]} />
                                            <View style={[styles.row, styles.centerAlign, styles.circle, { marginLeft: 50, padding: 3, borderColor: "red", borderWidth: 0 }]}>
                                                {this.props.t("fault") ? (
                                                    <>
                                                        {/*<Text style={{ color: "red", fontSize: 14, marginRight: 2 }}>{this.props.t("fault")}</Text>*/}
                                                        <Text style={{ color: "red", fontWeight: "bold", marginRight: 2, fontSize: 21 }}>{sentencePs[0]}</Text>
                                                        <Text style={{ color: "red", fontWeight: "bold", fontSize: 14, marginTop: 5 }}>
                                                            .{sentencePs[1]} {this.props.t("points")}
                                                        </Text>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Text style={{ color: "red", fontWeight: "bold", marginRight: 2, fontSize: 20 }}>{sentencePs[0]}</Text>
                                                        <Text style={{ color: "red", fontWeight: "bold", fontSize: 12, marginTop: 5 }}>
                                                            .{sentencePs[1]} {this.props.t(currDeductPoints < -1 ? "points" : "point")}
                                                        </Text>
                                                    </>
                                                )}
                                            </View>
                                            <Image source={require("../../../images/homework/result/drop.png")} style={{ marginLeft: 5, resizeMode: "stretch", width: 15, height: 20 }} />
                                        </View>
                                    ) : currDeductPoints === lastDeductPoints ? ( //不变
                                        <View style={[styles.row, styles.centerAlign, { marginTop: 30 }]}>
                                            <Image source={require("../../../images/homework/result/noChange.png")} style={[{ width: 100, height: 100, resizeMode: "contain" }]} />
                                            <View style={[styles.row, styles.centerAlign, styles.circle, { marginLeft: 50, padding: 3, borderColor: "orange", borderWidth: 0 }]}>
                                                {this.props.t("fault") ? (
                                                    <>
                                                        {/*<Text style={{ color: "orange", fontSize: 14, marginRight: 2 }}>{this.props.t("fault")}</Text>*/}
                                                        <Text style={{ color: "orange", fontWeight: "bold", marginRight: 2, fontSize: 21 }}>{sentencePs[0]}</Text>
                                                        <Text style={{ color: "orange", fontWeight: "bold", fontSize: 14, marginTop: 5 }}>
                                                            .{sentencePs[1]} {this.props.t("points")}
                                                        </Text>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Text style={{ color: "orange", fontWeight: "bold", marginRight: 2, fontSize: 20 }}>{sentencePs[0]}</Text>
                                                        <Text style={{ color: "orange", fontWeight: "bold", fontSize: 12, marginTop: 5 }}>
                                                            .{sentencePs[1]} {this.props.t(currDeductPoints < -1 ? "points" : "point")}
                                                        </Text>
                                                    </>
                                                )}
                                            </View>
                                        </View>
                                    ) : (
                                        <View style={[styles.row, styles.centerAlign, { marginTop: 30 }]}>
                                            <Image source={require("../../../images/homework/result/scoreImprovement.png")} style={[{ width: 100, height: 100, resizeMode: "contain" }]} />
                                            <View style={[styles.row, styles.centerAlign, styles.circle, { marginLeft: 50, padding: 3, borderColor: "green", borderWidth: 0 }]}>
                                                {this.props.t("fault") ? (
                                                    <>
                                                        {/*<Text style={{ color: "green", fontSize: 14, marginRight: 2 }}>{this.props.t("fault")}</Text>*/}
                                                        <Text style={{ color: "green", fontWeight: "bold", marginRight: 2, fontSize: 21 }}>{sentencePs[0]}</Text>
                                                        <Text style={{ color: "green", fontWeight: "bold", fontSize: 14, marginTop: 5 }}>
                                                            .{sentencePs[1]} {this.props.t("points")}
                                                        </Text>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Text style={{ color: "green", fontWeight: "bold", marginRight: 2, fontSize: 20 }}>{sentencePs[0]}</Text>
                                                        <Text style={{ color: "green", fontWeight: "bold", fontSize: 12, marginTop: 5 }}>
                                                            .{sentencePs[1]} {this.props.t(currDeductPoints < -1 ? "points" : "point")}
                                                        </Text>
                                                    </>
                                                )}
                                            </View>
                                            <Image source={require("../../../images/homework/result/improvement.png")} style={{ marginLeft: 5, resizeMode: "stretch", width: 15, height: 20 }} />
                                        </View>
                                    ) //上升
                                    }
                                    <TouchableOpacity
                                        style={[styles.centerAlign, { marginTop: 40, height: 40, width: 160, borderRadius: 18, backgroundColor: "#0099FF" }]}
                                        transparent
                                        onPress={this._handleCloseDialog}>
                                        <Text style={{ color: "#fff", fontSize: 13, fontWeight: "bold" }}>{this.props.t("confirm")}</Text>
                                    </TouchableOpacity>
                                </View>
                            </View>
                        </TouchableWithoutFeedback>
                    </View>
                </TouchableWithoutFeedback>
            </Modal>
        );
    };

    //override
    backgroundStopRecordCallback = () => {
        this.resetScreen(() => {
            if (this.state.recording) {
                this.endRecord();
                this.setState({
                    paused: true,
                    audioPath: "",
                    playingAll: false,
                    recording: false,
                    endRecording: false,
                    reIdentifing: false,
                });
                /*
                let { files, answer } = _.cloneDeep(this.props.result) || {};
                if (!files) {
                    files = [];
                }
                if (!answer) {
                    answer = {};
                }
                //const { words, audioPath, translation, sentenceCommand, sentenceCommandSetting } = this.props.data;
                this.setState({
                    paused: true,
                    audioPath: "",
                    playingAll: false,
                    recording: false,
                    endRecording: false,
                    reIdentifing: false,
                    showResultDialogIndex: null,
                    lastAnswer: answer,
                    currAnswer: {},

                    oriFiles: files && files.length > 0 ? files[0] : "",
                    words: null,
                    answer: answer,
                    subjectPoints: 0,
                });
                 */
            }
        });
    };
}

const styles = StyleSheet.create({
    row: {
        flexDirection: "row",
    },
    justifyContentBetween: {
        justifyContent: "space-between",
    },
    centerAlign: {
        justifyContent: "center",
        alignItems: "center",
    },
    alignItemsCenter: {
        alignItems: "center",
    },
    justifyContentCenter: {
        justifyContent: "center",
    },
    flex1: {
        flex: 1,
    },
    flex2: {
        flex: 2,
    },
    flex3: {
        flex: 3,
    },
    flex6: {
        flex: 6,
    },
    closeIcon: {
        color: "#fff",
    },
    headerTitle: {
        color: "#fff",
        fontSize: 17,
        fontWeight: "bold",
    },
    headerImage: {
        flex: 1,
        resizeMode: "cover",
        justifyContent: "flex-start",
    },
    marginHorizontal10: {
        marginHorizontal: 10,
    },
    circle: {
        height: 74,
        //width: 74,
        //borderRadius: 1000,
    },
    btnTopic: {
        borderColor: "#22D59E",
        borderWidth: 1,
        borderRadius: 15,
        width: 100,
        justifyContent: "center",
        alignItems: "center",
        height: 30,
    },
});

export default withTranslation(uid)(POKA3ResultView);
